import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export type LabelProps = {
  content: string;
  optionalLabel?: boolean;
  forRef?: string;
};

const BASE_LABEL_CLASSES = 'font-medium mb-2 block text-gray-700';
const LABEL_CLASSES = 'font-medium';
const OPTIONAL_LABEL_CLASSES = 'font-regular';

export const Label: FC<LabelProps> = ({
  content = 'Label',
  optionalLabel,
  forRef,
}: LabelProps) => {
  const { t } = useTranslation();
  return (
    <span className={BASE_LABEL_CLASSES}>
      <label className={LABEL_CLASSES} htmlFor={forRef}>
        {content}
      </label>
      {optionalLabel && (
        <span className={OPTIONAL_LABEL_CLASSES}>{` (${t(
          'labels:optional',
        )})`}</span>
      )}
    </span>
  );
};
